export class Pool {
    public scaleId: number;
    public collectionAlias: string;
}
